import React, {useEffect, useReducer, useRef, useState} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import FeatureName from "../../visComponents/featureName";
import AllFeaturesChecker from "../../visComponents/allFeaturesChecker";
import {EditIcon} from "../../common/icons";
import {getCurrentLayout} from "../../appLayout";
import useDebounce, {useOutsideClick} from "../../../misc/helperHooks";
import sqftShapeManager from "../../sqft/components/canvas/store/sqftShapeManager";
import {getNavItemsFromTheWizard} from "../../sqft/helpers/sqftHelperUi";
import sqftShapeIntersectionsManager from "../../sqft/components/canvas/store/sqftShapeIntersectionsManager";
import {prepareSQFTData} from "../../sqft/components/canvas/core/workspace/workspaceDataMapper";
import {saveSQFTDataToQuote} from "../../sqft/helpers/sqftQuotesHelper";
import workspaceControllers from "../../sqft/components/canvas/store/workspaceControllers";
import {HANDLE_TO_CABINETS, SQFT_FEATURES} from "../../sqft/constants";
import workspace from "../../sqft/components/canvas/core/workspace";
import {searchProductRequest} from "../../../api/search-api";
import {clearCacheForTheEdgeFeatures} from "../../../actions/sqftMenuFunctions";
import {setWizardConflictSteps, setWizardSelectedValues} from "../../../actions/wizardFunctions";
import {setWizardConflictPopupOpened} from "../../../actions/wizardFunctions";
import {setSQFTCartItemsToAdd} from "../../../actions/sqftResourceFunctions";

const filterNavItemsWithSearch = (navItems, productText) => {
  if (!productText) {
    return navItems
  }
  const searchString = productText.toLowerCase();
  return navItems.filter(navItem => {
    const name = navItem && navItem.part && navItem.part.getFeatureName ? navItem.part.getFeatureName() : "";
    return name && name.toLowerCase().includes(searchString)
  })
}

const SqftFeaturesPopupFeatureDropdown = (props) => {

  const {parentsList, rebuildQuoteLists, sqftFeature, editButtonColor, clearCacheForTheEdgeFeatures, setWizardSelectedValues,
    wizardIsActive, wizardActiveItem, setWizardConflictPopupOpened, wizardConflictingSteps} = props;
  const {feature, subPart, fromWizardGroupId} = sqftFeature;

  const [productText, setProductText] = useState("");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [loaderVisible, setLoaderVisible] = useState(false);
  const [namesArray, setNamesArray] = useState([]);
  const [updateCount, forceUpdate] = useReducer(x => x + 1, 0);
  const dropdownElement = useRef(null);
  const inputElement = useRef(null);

  useOutsideClick(dropdownElement, () => {
    setDropdownVisible(false);
  }, true);

  useEffect(() => {
    if (wizardConflictingSteps && wizardConflictingSteps?.length) {
      setWizardConflictPopupOpened(true);
    }
  }, [wizardConflictingSteps, setWizardConflictPopupOpened]);

  const handleInputChange = (event) => {
    setProductText(event.target.value);
  }

  const handleNavItemClick = async (navItem) => {
    navItem.part.handleClick();
    // update feature in calculator
    sqftShapeManager.setShapeFeature(sqftFeature.sqftId, navItem.part);
    sqftShapeManager.updateShapeColorSet(sqftFeature.sqftId);
    sqftShapeIntersectionsManager.updateSlabPlaceholderFeatureId();
    //sqftShapeIntersectionsManager.updateShapesFeaturePlacedOnSlabImages();
    sqftShapeIntersectionsManager.updateSlabImagesFeature();

    // update parent features feature in calculator
    if (sqftFeature.shouldUseRelatedParentFeatureAsMain) {
      for (const sqftId of sqftFeature.sqftIds) {
        sqftShapeManager.setShapeRelatedParentFeatureId(sqftId, navItem.part.dbFeature.id, navItem.part.partId);
      }
    }

    if (navItem.part.partId === SQFT_FEATURES.hinge) {
      workspaceControllers.hinge.updateResourcesId(navItem.part.dbFeature.id, navItem.part.partId)
    }

    if (navItem.part.partId.includes('handle')) {
      const shapes = workspace.getShapesWithoutAttachedResources();
      const selectedShapes = shapes.filter(shape => HANDLE_TO_CABINETS[navItem.part.partId].includes(shape.partId));
      workspaceControllers.handles.changeHandlesForSelectedShapes(selectedShapes, navItem.part, sqftFeature.quantityGroup)
    }

    // //update parentList with new navItem
    // let updatedLists = [...parentsLists];
    // let updatedList = {...parentsList};
    // const parentListIndex = parentsLists.findIndex(pList => pList === parentsList);
    // updatedList[parentKey].features[sqftFeatureIndex].feature = navItem.part;
    // if (navItem.newWizardGroupId) {
    //   // updatedList[parentKey].features[sqftFeatureIndex].fromWizardGroupId = navItem.newWizardGroupId;
    //   // we can't do that, we need to have all features, from all groups, so we can't pass direct group id here
    //   updatedList[parentKey].features[sqftFeatureIndex].newWizardGroupId = navItem.newWizardGroupId;
    //   // console.log("updated!", updatedList[parentKey].features[sqftFeatureIndex]);
    // }
    // if (isRecalculateSlabNeeded(parentsList)) {
    //   updatedList = recalculateSlabs(updatedList);
    // }
    // updatedLists[parentListIndex] = updatedList;
    // setParentsLists(updatedLists);

    if (wizardIsActive && wizardActiveItem && navItem.newWizardStep && navItem.newWizardGroup) {
      setWizardSelectedValues({
        [navItem.newWizardStep]: {
          wizardGroup: navItem.newWizardGroup,
          selectedFeature: navItem.part,
          partId: navItem.part.partId,
        }
      });
    }

    let sqftCalcData = await prepareSQFTData();
    await saveSQFTDataToQuote(sqftCalcData);

    // const {addedFeatures} = computeAddedFeatures([parentsList]);
    // const tempCartItems = addUUIDToCartItems(addedFeatures);
    // console.log("tempCartItems", tempCartItems);
    // const {wizardConflictingSteps} = checkWizardConflictingSteps(tempCartItems);
    // if (wizardConflictingSteps) {
    //   setWizardConflictSteps(wizardConflictingSteps);
    //   setSQFTCartItemsToAdd(tempCartItems);
    //   //handleOpenModalFix({changeWizardStepRoute, wizardConflictingSteps});
    // }
    // console.log("wizardConflictingSteps", wizardConflictingSteps);

    // wi will update parent list on quotes change
    void rebuildQuoteLists;
    setDropdownVisible(false);
    clearCacheForTheEdgeFeatures();
  };

  const getNamesArray = () => {
    if (dropdownVisible) {
      if (!subPart.part.allFeaturesReceived) {
        return [{loader: true}]
      }
      if (wizardIsActive) {
        const wizNavItems = getNavItemsFromTheWizard(subPart, "", {}, fromWizardGroupId, visualizerType, parentsList);
        return filterNavItemsWithSearch(wizNavItems, productText)
      }
      const layout = getCurrentLayout();
      const navItems = layout.designNavigationItems(subPart, {}, "", false, true);
      return filterNavItemsWithSearch(navItems, productText);
    }
    return []
  }

  useDebounce(async () => {
    if (productText && subPart.part && subPart.part.allFeaturesReceived && !subPart.part.getRealFeaturesReceivedProperty()) {
      return searchProductRequest(subPart.part, productText, setLoaderVisible)
    }
  }, [productText], 800);

  const editButtonClick = () => {
    if (dropdownVisible) {
      setDropdownVisible(false)
    } else {
      setDropdownVisible(true);
      if (inputElement && inputElement.current) {
        inputElement.current.focus()
      }
    }
  };

  const visualizerType = parentsList.quote ? parentsList.quote.room : document.kvConfig.visualizerType;

  useEffect(() => {
    if (loaderVisible) {
      return; // request is already going on
    }
    if (productText && subPart.part && subPart.part.allFeaturesReceived && !subPart.part.getRealFeaturesReceivedProperty()
      && !(Array.isArray(subPart.part.alreadyRequestedFeatureNames)
        && subPart.part.alreadyRequestedFeatureNames.some(alreadyRequestedText => {
          return alreadyRequestedText === productText || productText.includes(alreadyRequestedText) // arcilla red -> arcilla red suede
        }))) {
      setNamesArray([])
      searchProductRequest(subPart.part, productText, setLoaderVisible)
      return
    }
    setNamesArray(getNamesArray())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownVisible, wizardIsActive, subPart, fromWizardGroupId, visualizerType, productText, updateCount,
    loaderVisible]);

  const styles = {
    height: dropdownVisible
      ? loaderVisible
        ? 62
        : namesArray.length * 30 + 32
      : 0,
    width: dropdownVisible ? "100%" : 0,
  }

  return (
    <div className="u-leading-1 u-pr-05 sqft-popup__feature-name" ref={dropdownElement}>
      <button className="sqft-popup__feature-edit" onClick={editButtonClick} >
        <EditIcon color={editButtonColor}/>
      </button>
      {feature
        ? <FeatureName feature={feature}/>
        : <FormattedMessage id="sqftFeaturesPopup.noFeatureSelected"/>}
      <div className="sqft-popup__dropdown aq-dropdown" style={styles}>
        <input className="ui-input ui-input--new ui-input--gray"
               value={productText}
               ref={inputElement}
               onChange={handleInputChange}/>
        <ul className="aq-list">
          {loaderVisible ? (
            <li className="aq-list__item bold aq-list__item--loading">
              <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
            </li>
          ) : namesArray.map((navItem, navItemIndex) => {
            return navItem.loader ? (
              <AllFeaturesChecker subPart={subPart}
                                  key="aq-list-loader" ignored={updateCount} callBack={forceUpdate}/>
            ) : (
              <li className="aq-list__item bold" key={navItemIndex} onClick={() => handleNavItemClick(navItem)}>
                <FeatureName feature={navItem.part}/>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
};

SqftFeaturesPopupFeatureDropdown.propTypes = {
  parentsList: PropTypes.object.isRequired,
  parentsLists: PropTypes.array.isRequired,
  setParentsLists: PropTypes.func.isRequired,
  editButtonColor: PropTypes.string.isRequired,
  sqftFeature: PropTypes.object.isRequired,
}

const mapStateToProps = (store) => {
  const {wizardIsActive, wizardActiveItem, wizardConflictingSteps} = store.wizardState;
  return {
    activeTheme: store.serverState.activeTheme,
    wizardIsActive,
    wizardActiveItem,
    wizardConflictingSteps,
  };
};
const mapDispatchToProps = {
  clearCacheForTheEdgeFeatures,
  setWizardSelectedValues,
  setWizardConflictPopupOpened,
  setWizardConflictSteps,
  setSQFTCartItemsToAdd,
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupFeatureDropdown)
